<template>
    <HamletTable
        ref="table"
        :columns="columns"
        :fetch="fetch"
        @onRowClick="onRowClick"
    >
        <template #header-label>
            {{ $t('Page(PagesNews):Component(Text):page-label') }}
        </template>

        <template #header-controls>
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mt-0 btn-icon"
                @click="addCategory"
            >
                <feather-icon icon="PlusIcon" />
            </b-button>
        </template>

        <template #cell-image="data">
            <div v-if="data.item.image">
                <b-img
                    rounded
                    width="140"
                    :src="data.item.image"
                />
            </div>
            <div v-else>
                -
            </div>
        </template>

        <template #cell-visible="data">
            <b-badge :variant="data.item.isVisible ? 'success' : 'secondary'">{{ data.item.isVisible ? 'yes' : 'no' }}</b-badge>
        </template>

        <template #cell-actions="data">
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="danger"
                class="mt-0 btn-icon"
                @click.stop="remove(data.item)"
            >
                <feather-icon icon="Trash2Icon" />
            </b-button>
        </template>

    </HamletTable>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import {BButton, BImg, BBadge} from 'bootstrap-vue'
import HamletTable from "@core/components/common/HamletTable";
import {PagesApi} from "@core/api";

export default {
    directives: {Ripple},
    components: {HamletTable, BButton, BImg, BBadge},
    data() {
        return {
            columns: [
                {
                    key: 'image',
                    label: this.$t('Component(Grid):column-image')
                },
                {
                    key: 'visible',
                    label: this.$t('Component(Grid):column-visible')
                },
                {
                    key: 'title',
                    label: this.$t('Component(Grid):column-name')
                },
                {
                    key: 'slug',
                    label: this.$t('Component(Grid):column-slug')
                },
                {
                    key: 'actions',
                    label: this.$t('Component(Grid):column-actions')
                }
            ],
        };
    },
    methods: {
        onRowClick(category) {
            this.$router.push({
                name: 'administration-pages-news-edit',
                params: {
                    id: category.id
                }
            })
        },
        remove(news) {
            PagesApi
                .deleteNews(news.id)
                .then(() => {
                    this.$refs.table.makeRequest();
                });
        },
        addCategory() {
            this.$router.push({name: 'administration-pages-news-add'});
        },
        fetch(config, cb) {
            PagesApi.news(config.page, config.perPage).then(r => {
                cb(r.data.totalItems, r.data.items);
            });
        }
    }
}
</script>
